export type SubjectDialogMessages = {
  deleteTitle: string;
  deleteContent: string;
  deleteCancel: string;
  deleteConfirm: string;
};

export const SUBJECT_DIALOG_MESSAGES: SubjectDialogMessages = {
  deleteTitle: "Excluir Assunto",
  deleteContent: "Tem certeza de que deseja excluir este assunto?",
  deleteCancel: "Cancelar",
  deleteConfirm: "Confirmar",
};
